export default "__VITE_ASSET__28405s64__"